const formatWebtestError = (error) => {
  if (!error) return null
  return error?.message || 'An unknown error occurred while fetching WebTEST predictions.'
}

export { formatWebtestError }
